import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Container from "react-bootstrap/Container";
import { useForm, ValidationError } from "@formspree/react";
import { Redirect } from "react-router-dom";
import Alert from "react-bootstrap/Alert";

function Contactform() {
  const [state, handleSubmit] = useForm("xbjqblbv");
  if (state.succeeded) {
    return (
      <>
        <Alert variant="success">Thanks for contacting!</Alert>
      </>
    );
  }
  return (
    <Container className="col-6">
      <Form onSubmit={handleSubmit}>
        <Form.Group className="mb-3">
          <Form.Label className="my-3 h4" htmlFor="email">
            Email Address
          </Form.Label>
          <Form.Control
            id="email"
            type="email"
            name="email"
            placeholder="example@email.com"
          />
        </Form.Group>
        <ValidationError prefix="Email" field="email" errors={state.errors} />
        <Form.Control
          className="mb-3"
          as="textarea"
          rows={3}
          id="message"
          name="message"
          placeholder="message"
        />
        <ValidationError
          prefix="Message"
          field="message"
          errors={state.errors}
        />
        <Button className="btn-cust" type="submit" disabled={state.submitting}>
          Submit
        </Button>
      </Form>
    </Container>
  );
}

export default Contactform;
